import { useAtom } from "jotai"
import { useEffect, useState } from "react"
import Link from "next/link"
import { useRouter } from "next/router"
import { trackingPreferencesAtom } from "app/state"

const CookieConsent = () => {
  const [preferences, setPreferences] = useAtom(trackingPreferencesAtom)
  const [mounted, setMounted] = useState(false)
  const router = useRouter()

  // Ensure the component is only rendered on the client side
  // useEffect only runs in the client
  // so the server returns null. This prevents hydration mismatches
  useEffect(() => {
    setMounted(true)
  }, [])

  // Hide on the manage-tracking page (user is already managing preferences there)
  if (!mounted || preferences !== undefined || router.pathname === "/manage-tracking") {
    return null
  }

  const handleAcceptAll = () => {
    setPreferences({ analytics: true, sessionReplay: true })
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:right-4">
      <div className="w-full rounded-lg border border-gray-200 bg-white px-4 py-4 text-center shadow-xl md:w-80">
        <p className="text-center text-xs text-gray-700">
          We use cookies to optimize your user experience with our website. View our{" "}
          <Link
            href="/privacy"
            className="text-xs text-brand-green-dark transition-colors hover:text-brand-green"
          >
            Privacy Policy{" "}
          </Link>
        </p>
        <div className="mb-3 mt-3 flex justify-around gap-3">
          <Link
            href="/manage-tracking"
            className="flex-1 rounded-full bg-gray-100 py-2 text-xs text-gray-600 transition-colors hover:bg-gray-200"
          >
            Manage Preferences
          </Link>
          <button
            onClick={handleAcceptAll}
            className="flex-1 rounded-full bg-brand-green-dark py-2 text-xs text-white transition-colors hover:bg-brand-green"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  )
}

export default CookieConsent
